import enhancedFetch from "Utils/enhancedFetch";
import { API_URL } from "Utils/envVariables";
import { FETCH_DEFAULT_CONFIGS_TOKEN } from "../config";
import { CbTransferInfoResponse, cbTransferInfoResponseDecoder } from "./interfaces";

export const cbPdfUrl = `${API_URL}/cb/accounts_file/?type=PDF`;

export async function getCbTransferInfo(): Promise<CbTransferInfoResponse> {
  const response = await enhancedFetch(`${API_URL}/cb/transfer_info/`, {
    ...FETCH_DEFAULT_CONFIGS_TOKEN(),
    method: "GET",
  });

  return cbTransferInfoResponseDecoder.verify(await response.json());
}

export async function getCbAccountsDocument(type: "" | "PDF" = "") {
  const query = new URLSearchParams({ type }).toString();
  const response = await enhancedFetch(`${API_URL}/cb/accounts_file/${type ? `?${query}` : ""}`, {
    ...FETCH_DEFAULT_CONFIGS_TOKEN(),
    method: "GET",
  });

  return response.blob();
}
